<ppl-accordion [title]="'Year End Tax Document Printing Elections'" [isOpen]="true" *authorize="[pageId, tabId, 'printingElection', 'section']">
  <form nz-form [formGroup]="taxDocumentForm" class="ppl-p0">
    <div class="container">
      @if(showCheckbox || CanViewPrintingElection){
        <div>
          <nz-form-item class="ppl-form-item">
            <nz-form-control class="ppl-form-control" nz-tooltip style="margin: 12px 0;">
              <ng-container>
                <label nz-checkbox formControlName="consent" [nzDisabled]="CanViewPrintingElection">
                  I have received verbal authorization to change the Provider's Tax Form Election.
                </label>
              </ng-container>
            </nz-form-control>
          </nz-form-item>
        </div>
        }
      <div style="display: flex; justify-content: space-between; align-items: center;" class="ppl-mt8">
        <div>
          <span class="label-bold">Election Last Updated:</span> {{electionDate || '-'}}
        </div>
        @if(mode==='edit'){
        <div class="custom-row">
          <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
            (click)="saveDetails()" class="ppl-mr8">
          </ppl-button>
          <ppl-button label="Cancel" icon="fa fa-close" [customClass]="'alt-button'" [iconPosition]="'left'"
            (click)="cancel()">
          </ppl-button>
        </div>
        }
        @else {
        @if(canEditPrintingElection || CanViewPrintingElection){
        <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'" [iconPosition]="'left'"
          (click)="editDetails()" [disabled]="(showCheckbox && !taxDocumentForm.get('consent')?.value) || CanViewPrintingElection">
        </ppl-button>
        }
        }
      </div>


      <div class="section">
        <span class="label-bold">Current Year End Form Printing Election:</span>
        {{selectedElectionValue}}
      </div>
      <br>
      <br>
      <nz-form-item class="ppl-form-item">
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="election" class="ppl-form-label">New Election
        </nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-radio-group formControlName="election" nzDirection="vertical" [nzDisabled]="disableSelection">
            <label nz-radio nzValue="N" style="width: 100%">Receive electronic copies of my Year End Tax
              Documents</label>
            <label nz-radio nzValue="Y" style="width: 100%">Receive both electronic and paper copies of my Year End
              Tax Documents</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>


      <div class="label-bold">
        Important Note: If you select the option to "Receive electronic copies of my Year End Tax Documents":
      </div>
      <br>
      <div class="disclaimer">
        <span class="label-bold">Disclaimer:</span>
        A computer with Internet access and Adobe Reader is required to view and print tax documents. After you select
        the option to receive tax documents electronically, this selection will remain valid for all future tax years or
        until you change your preference (so this process does not need to be repeated). If you do not choose to receive
        tax documents electronically, you will receive a paper copy of your Year End Forms (Original/Corrected) to the
        mailing address we have on file in PPL&#64;Home (please ensure this address is correct). Even if you choose to
        receive
        electronic tax forms, you will still be able to access the electronic versions as well. If you have any
        questions,
        please contact customer service at 1-833-247-5346.
      </div>
    </div>
  </form>
</ppl-accordion>

<ppl-accordion [title]="'Tax Document Summary'" [isOpen]="true" *authorize="[pageId, tabId, 'taxSummary', 'section']">
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="taxDocsData"
    [disableSelection]="true" [cols]="cols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
    [actionButtons]="actions" (gridAction)="action($event)">
  </ppl-list-table>
</ppl-accordion>

@if(retirementDocsEligible && retirementDocsData.length){
<ppl-accordion [title]="'Retirement Plan Documents'" [isOpen]="true" *authorize="[pageId, tabId, 'retirementPlanDocuments', 'section']">
  @if(isRetirementHistoryRole){
  <div class="retirement-history-action">
    <ppl-button ariaLabel="Document History" label="Document History" icon="fa fa-history" [customClass]="'ghost-button'"
      [iconPosition]="'left'" (click)="openRetirementHistory()"></ppl-button>
  </div>
  }
  <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="retirementDocsData"
    [disableSelection]="true" [cols]="retirementDocsCols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
    [actionButtons]="retirementDocsActions" (gridAction)="retirementDocAction($event)">
  </ppl-list-table>
</ppl-accordion>
}

<div class="filter-panel">
  <ng-template #retirementHistoryDialog let-cancel="cancel">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false"
      [data]="retirementHistoryData" [disableSelection]="true" [cols]="retirementHistoryCols"
      [gridTitle]="false" [pagination]="false">
    </ppl-list-table>
  </ng-template>
  <ng-template #documentDialog let-cancel="cancel">
    @if(pdfSrc){
      <div class="">
        <ngx-extended-pdf-viewer [src]="pdfSrc" [showToolbar]="false" useBrowserLocale="true" height="90vh">
        </ngx-extended-pdf-viewer>
    </div>
    }
  </ng-template>
</div>